import { render, staticRenderFns } from "./baseGeometry.vue?vue&type=template&id=133b4127&scoped=true&"
import script from "./baseGeometry.vue?vue&type=script&lang=ts&"
export * from "./baseGeometry.vue?vue&type=script&lang=ts&"
import style0 from "./baseGeometry.vue?vue&type=style&index=0&id=133b4127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b4127",
  null
  
)

export default component.exports